import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import { InfoDivider } from '../../../AtBat/atbat.style';
import {
    UpcomingBattersContainer,
    UpcomingBatterWrapper,
    UpcomingLabel,
    UpcomingStats,
    MainWrapper
} from './UpcomingBatters.style';

const UpcomingBatters = ({
    inHole: {
        battingOrder: inHoleBattingOrder = '',
        person: {
            boxscoreName: inHoleBoxscoreName
        } = {},
        stats: {
            batting: {
                hits: inHoleHits,
                atBats: inHoleAtBats
            } = {}
        } = {}
    } = {},
    onDeck: {
        battingOrder: onDeckBattingOrder = '',
        person: {
            boxscoreName: onDeckBoxscoreName
        } = {},
        stats: {
            batting: {
                hits: onDeckHits,
                atBats: onDeckAtBats
            } = {}
        } = {}
    } = {},
    isMobile
}) => {
    const hasData = onDeckBoxscoreName || inHoleBoxscoreName;

    return (
        hasData
            ? <MainWrapper>
                <InfoDivider />
                <UpcomingBattersContainer>
                    <UpcomingBatterWrapper>
                        <UpcomingLabel>{ `${useTranslator('game_ondeck', 'On deck')}: ` }</UpcomingLabel>
                        <UpcomingStats>{ onDeckBoxscoreName } { onDeckHits } - { onDeckAtBats }</UpcomingStats>
                    </UpcomingBatterWrapper>
                    <UpcomingBatterWrapper>
                        <UpcomingLabel>{ `, ${useTranslator('game_inthehole', 'In the hole')}: `}</UpcomingLabel>
                        <UpcomingStats><span>{ inHoleBoxscoreName }</span> { inHoleHits } - { inHoleAtBats }</UpcomingStats>
                    </UpcomingBatterWrapper>
                </UpcomingBattersContainer>
                {isMobile && <InfoDivider />}
            </MainWrapper>
            : null
    );
};

UpcomingBatters.propTypes = {
    inHole: PropTypes.object,
    onDeck: PropTypes.object,
    isMobile: PropTypes.bool
};

export default UpcomingBatters;
